import type { Marlin } from './marlin';
import { defineReporter } from '@zg-rentals/monitor-base';
import { reason } from '@zg-rentals/stdlib/task';

export default (marlin: Marlin, appName: string, serverName: string) =>
  defineReporter({
    count: (name, amount) =>
      marlin
        .sendCounts({
          serviceName: appName,
          serverName: serverName,
          countStats: {
            [Date.now()]: {
              [name]: { sum: amount },
            },
          },
        })
        .mapRejected(reason('marlinReporter counts error')),

    gauges: (name, amount) =>
      marlin
        .sendGauges({
          serviceName: appName,
          serverName: serverName,
          gauges: {
            [Date.now()]: {
              [name]: {
                count: 1,
                sum: amount,
                min: amount,
                max: amount,
              },
            },
          },
        })
        .mapRejected(reason('marlinReporter gauges error')),

    measurementWithGauges: (name, amount) =>
      marlin
        .sendMeasurementWithGauges({
          serviceName: appName,
          serverName: serverName,
          measurements: {
            [name]: [{ timeMs: Date.now(), value: amount }],
          },
        })
        .mapRejected(reason('marlinReporter measurementWithGauges error')),
  });
